import type { RouterConfig } from '@nuxt/schema';

export default {
  scrollBehavior(to, _, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    if (to.hash) {
      return new Promise((resolve) => {
        onNuxtReady(() => {
          resolve({ el: to.hash, behavior: 'smooth' });
          history.replaceState(
            null,
            '',
            window.location.pathname + window.location.search,
          );
        });
      });
    }

    return { top: 0, left: 0 };
  },
} satisfies RouterConfig;
